import { render } from "./ticketsSharePopup.vue?vue&type=template&id=15302de8"
import script from "./ticketsSharePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ticketsSharePopup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/components/ticketsSharePopup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15302de8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15302de8', __exports__)) {
    console.log('reload')
    api.reload('15302de8', __exports__)
  }
  
  module.hot.accept("./ticketsSharePopup.vue?vue&type=template&id=15302de8", () => {
    console.log('re-render')
    api.rerender('15302de8', render)
  })

}


export default __exports__